import React, { FC, useEffect } from "react";

import { PaymentFlowLayout } from "../../../Components/Layouts/PaymentFlowLayout/PaymentFlowLayout";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import { useSavePaymentPreferencesFlow } from "@modules/PaymentProcessing/hooks/useSavePaymentPreferencesFlow";
import { PaymentMethodSelect } from "@modules/PaymentProcessing/Components/PaymentMethodSelect/PaymentMethodSelect";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";
import { BackLink } from "@Shared/Components/BackLink/BackLink";
import { useNavigate } from "@Libs/Router/hooks/useNavigate";

export const ChoosePaymentMethod: FC<{
  showPayPalAsPaymentMethod?: boolean;
}> = ({ showPayPalAsPaymentMethod }) => {
  const {
    state: { operationSummary, allowedPaymentMethods, enabledPaymentMethods },
    onPageMount,
    navigateToStep,
    // backRoute,
  } = useSavePaymentPreferencesFlow();
  const navigate = useNavigate();

  const handlePaymentMethodSelect = (paymentMethod: PaymentMethodType) => {
    navigateToStep("CONFIGURE_PAYMENT_METHOD", {
      queryParams: {
        paymentMethod,
      },
    });
  };

  useEffect(() => {
    onPageMount?.("CHOOSE_PAYMENT_METHOD");
  }, []);

  const handleBack = () => {
    // navigate(backRoute.to, backRoute);
    navigate("", { back: true });
  };

  return (
    <PaymentFlowLayout>
      <PaymentFlowLayout.Nav>
        <BackLink onClick={handleBack} />
      </PaymentFlowLayout.Nav>
      <PaymentFlowLayout.OperationSummary>
        {operationSummary}
      </PaymentFlowLayout.OperationSummary>
      <PaymentFlowLayout.Header>
        <FormattedMessage {...messages.chooseYourPaymentMethod} />
      </PaymentFlowLayout.Header>
      <PaymentFlowLayout.Content>
        <PaymentMethodSelect
          onSelect={handlePaymentMethodSelect}
          showCash
          allowedPaymentMethods={allowedPaymentMethods}
          enabledPaymentMethods={enabledPaymentMethods}
          showPayPalAsPaymentMethod={showPayPalAsPaymentMethod}
        />
      </PaymentFlowLayout.Content>
    </PaymentFlowLayout>
  );
};
